import FullWidthSection from '@/components/full-width-section';
import { Button } from '@/components/ui/button';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from '@/components/ui/carousel';
import { AWARD_CARD_DATA } from '@/data/franchise/data';
import Autoplay from 'embla-carousel-autoplay';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useEffect, useState } from 'react';
import AwardCard from './award-card';

export default function AwardSection() {
  const [emblaApi, setEmblaApi] = useState<CarouselApi>();
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    emblaApi.on('select', onSelect);
    onSelect(); // 초기값 설정
    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi]);
  return (
    <FullWidthSection>
      <div className="relative">
        <div className="flex h-[580px] bg-[url('/images/franchise/consult_prize_bg.png')] bg-cover bg-bottom bg-no-repeat">
          <Carousel
            setApi={setEmblaApi}
            opts={{ align: 'start', loop: true }}
            plugins={[Autoplay({ delay: 3000, stopOnInteraction: false })]}
            className="overflow-hidden"
          >
            <CarouselContent className="flex">
              {AWARD_CARD_DATA.map((item) => (
                <CarouselItem key={item.idx} className="flex-shrink-0">
                  <AwardCard key={item.idx} {...item} />
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>

        {/* 네비게이션 버튼 - 모바일에서는 작고 내부에 위치, 데스크톱에서는 크고 외부에 위치 */}
        <div className="desktop:web-w desktop:mx-auto desktop:relative">
          <Button
            onClick={() => emblaApi?.scrollPrev()}
            disabled={!emblaApi}
            className="desktop:left-10 desktop:-top-[280px] desktop:size-[55px] absolute top-1/2 left-6 flex size-9 -translate-y-1/2 items-center justify-center rounded-full border border-[#595B6A] bg-[#19191A]/60 p-0"
          >
            <ChevronLeft className="desktop:!w-6 desktop:!h-6 text-sub-white !h-3.5 !w-3.5 stroke-current" />
          </Button>
          <Button
            onClick={() => emblaApi?.scrollNext()}
            disabled={!emblaApi}
            className="desktop:right-10 desktop:-top-[280px] desktop:size-[55px] absolute top-1/2 right-6 flex size-9 -translate-y-1/2 items-center justify-center rounded-full border border-[#595B6A] bg-[#19191A]/60 p-0"
          >
            <ChevronRight className="desktop:!w-6 desktop:!h-6 text-sub-white !h-3.5 !w-3.5 stroke-current" />
          </Button>

          <span className="desktop:right-10 absolute right-6 bottom-8 h-6.5 w-17.25 rounded-full bg-[#111111]/70 text-center tabular-nums">
            <span className="typo-14 text-sub-white font-bold">
              {'0' + (selectedIndex + 1)}
            </span>{' '}
            <span className="typo-14 text-sub-white/50 font-medium">
              / {'0' + AWARD_CARD_DATA.length}
            </span>
          </span>
        </div>
      </div>
    </FullWidthSection>
  );
}
